/** Flush the focused field so onBlur handlers run before save. */
export const flushActiveFieldBeforeSave = () =>
  new Promise((resolve) => {
    const active = document.activeElement;
    if (
      active &&
      active !== document.body &&
      typeof active.blur === "function" &&
      (active.tagName === "INPUT" ||
        active.tagName === "TEXTAREA" ||
        active.tagName === "SELECT")
    ) {
      let settled = false;
      const done = () => {
        if (!settled) {
          settled = true;
          resolve();
        }
      };
      active.addEventListener("blur", done, { once: true });
      active.blur();
      setTimeout(done, 50);
    } else {
      resolve();
    }
  });

/** Read pricing inputs still using defaultValue (not yet blurred into state). */
export const syncPricingFieldsFromDom = (pricingRows) => {
  if (!Array.isArray(pricingRows)) return pricingRows || [];
  return pricingRows.map((row, index) => {
    const next = { ...row };
    const exEl = document.getElementById(`retailprice_Ex_${index}`);
    const incEl = document.getElementById(`retailprice_Inc_${index}`);
    const invEl = document.getElementById(`inv_retailprice_Inc${index}`);
    if (exEl && exEl.value !== undefined) {
      next.retailprice_Ex = exEl.value;
    }
    if (incEl && incEl.value !== undefined) {
      next.retailprice_Inc = incEl.value;
    }
    if (invEl && invEl.value !== undefined) {
      next.inv_retailprice_Inc = invEl.value;
    }
    return next;
  });
};

/** Read stone blur-controlled inputs that may not have flushed to state yet. */
export const syncStoneBlurFieldsFromDom = (stones) => {
  if (!Array.isArray(stones)) return stones || [];
  return stones.map((stone, index) => {
    const next = { ...stone };
    const certEl = document.getElementById(`certificateNo_${index}`);
    const pcsEl = document.getElementById(`stonePcs_${index}`);
    const weightEl = document.getElementById(`stoneWeight_${index}`);
    const priceEl = document.getElementById(`stonePrice_${index}`);
    if (certEl && certEl.value !== undefined) {
      next.certificateNo = certEl.value;
    }
    if (pcsEl && pcsEl.value !== undefined) {
      next.Pcs = pcsEl.value;
    }
    if (weightEl && weightEl.value !== undefined) {
      next.Weight = weightEl.value;
    }
    if (priceEl && priceEl.value !== undefined) {
      next.stonePrice = priceEl.value;
    }
    return next;
  });
};

/** Legacy empty-stone row uses react-hook-form register instead of stone state. */
export const mergeHookFormStoneFields = (stones, formData) => {
  if (!Array.isArray(stones)) return stones || [];
  return stones.map((stone, index) => {
    if (Object.keys(stone || {}).length === 0) {
      return {
        ...stone,
        Pcs: formData?.Pcs?.[index] ?? stone?.Pcs,
        Weight: formData?.Weight?.[index] ?? stone?.Weight,
        stonePrice: formData?.stonePrice?.[index] ?? stone?.stonePrice,
      };
    }
    return stone;
  });
};
